import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateRequestCountdown,
  removeExpiredRequest,
} from "../store/actions/notaryActions";

export const useRequestCountdowns = () => {
  const dispatch = useDispatch();
  const requestCountdowns = useSelector(
    (state) => state.notarySession.requestCountdowns,
  );
  const realTimeRequests = useSelector(
    (state) => state.notarySession.notaryRequests,
  );
  const intervalRef = useRef(null);

  useEffect(() => {
    // Start the countdown timer
    intervalRef.current = setInterval(() => {
      const updatedCountdowns = { ...requestCountdowns };
      let hasUpdates = false;

      // Update each countdown
      Object.keys(updatedCountdowns).forEach((requestId) => {
        const currentTime = updatedCountdowns[requestId];
        if (currentTime > 0) {
          updatedCountdowns[requestId] = currentTime - 1;
          hasUpdates = true;
        } else {
          // Request has expired, remove it
          dispatch(removeExpiredRequest(requestId));
          delete updatedCountdowns[requestId];
        }
      });

      // Dispatch updates for all active countdowns
      if (hasUpdates) {
        Object.keys(updatedCountdowns).forEach((requestId) => {
          dispatch(
            updateRequestCountdown(requestId, updatedCountdowns[requestId]),
          );
        });
      }
    }, 1000);

    // Cleanup interval on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [dispatch, requestCountdowns]);

  // Format time remaining as MM:SS
  const formatTimeRemaining = (seconds) => {
    if (seconds <= 0) return "00:00";
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  // Get time remaining for a specific request
  const getTimeRemaining = (requestId) => {
    return requestCountdowns[requestId] || 0;
  };

  // Check if a request is expired
  const isExpired = (requestId) => {
    return (requestCountdowns[requestId] || 0) <= 0;
  };

  return {
    requestCountdowns,
    formatTimeRemaining,
    getTimeRemaining,
    isExpired,
  };
};
